import Menu from '../components/Menu'
import Footer from '../components/Footer'
import * as SG from '../style/Styles'

export default function Template({children}:any) {

    return (
        <SG.Template>

            <Menu />

            <SG.Content className='content'>

                <div className='containerContant'>

                <SG.ContentChild>{children}</SG.ContentChild>
                
                <Footer />

                </div>
                
            </SG.Content>
           
        </SG.Template>
    );
}
  